module.exports = __webpack_public_path__ + "img/female6.ce457882.jpg";